// Resets the scroll position of a Kendo UI ListView component to the top.
export function resetListScroll(): void {
    const list = document.getElementsByClassName('k-listview-content').item(0) as HTMLElement;
    if (list && list.scrollTop > 0) {
        list.scrollTop = 0;
    }
}
